module.exports = __webpack_public_path__ + "img/s2.b02f303b.svg";